import { LucideExternalLink, LucideLink, LucideVideo } from 'lucide-react'
import { createActivity } from '~/api'
import { ActivityRelatedType, ActivityType, Listing } from '~/models'

type ListingLinksProps = {
  listing: Listing
}

export default function ListingLinks({ listing }: ListingLinksProps) {
  if ((listing.links || []).length === 0) {
    return null
  }
  return (
    <div className="sm:col-span-2">
      <div className="mt-2 text-base text-foreground">
        <ul role="list" className="divide-y divide-border rounded-md border">
          {listing.links!.map((link, index) => {
            return (
              <li key={index}>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between py-3 pl-3 pr-4 text-base hover:bg-muted"
                  onClick={() =>
                    createActivity({
                      type: ActivityType.viewLink,
                      relatedType: ActivityRelatedType.listing,
                      relatedId: listing._id,
                      meta: { link },
                    })
                  }>
                  <div className="flex w-0 flex-1 items-center">
                    {link.type === 'video' ? (
                      <LucideVideo
                        className="h-5 w-5 flex-shrink-0 text-muted-foreground"
                        aria-hidden="true"
                      />
                    ) : (
                      <LucideLink
                        className="h-5 w-5 flex-shrink-0 text-muted-foreground"
                        aria-hidden="true"
                      />
                    )}
                    <span className="ml-2 w-0 flex-1 truncate">
                      {link.name}
                    </span>
                  </div>
                  <div className="ml-4 flex-shrink-0">
                    <LucideExternalLink className="h-5 w-5 print:hidden" />
                  </div>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
